import { combineReducers } from "redux";
import {
  SET_IS_LOGGED_IN,
  SET_USER_DATA,
  SET_JOINT_ADDENDUM_STATE,
  SET_GENERAL_DETAILS,
  SET_COVID_AND_NRI_DETAILS,
  SET_TOAST_ERROR,
  SET_STEP_DETAILS,
  commonReducer,
  SET_OTP_VERIFICATION_DETAILS,
  SET_VERIFY_OTP_LEAD_ID,
  SET_LOAN_STATUS,
  SET_MEF_UPLOAD_MODAL,
  SET_PROPOSAL_STATUS,
  SET_SIGNATURE_MODAL,
  SET_NEW_LEAD_DETAILS
} from "./common";
import { medicalAndLifeStyleReducer } from "./medicalLifestyle";
import proposerDetailsReducer from "./proposerDetails";
import jointLifeReducer from "./jointLifeAddendum";
import loanDetailsReducer from "./loanDetails";
import dashboardReducer from "./dashboard";
import { MASTERDATA_REDUCER } from "./MasterReducer";
import assignmentClauseDetailsReducer from "./AssignmentClauseDetails";

const appReducer = combineReducers({
  user_data: SET_USER_DATA,
  loggedIn: SET_IS_LOGGED_IN,
  isJointAddendum: SET_JOINT_ADDENDUM_STATE,
  generalDetails: SET_GENERAL_DETAILS,
  covidAndNriDetails: SET_COVID_AND_NRI_DETAILS,
  toast_error: SET_TOAST_ERROR,
  proposerDetails: proposerDetailsReducer,
  jointLifeAddendum: jointLifeReducer,
  loanDetails: loanDetailsReducer,
  dashboard: dashboardReducer,
  masterdata_reducer: MASTERDATA_REDUCER,
  medicalAndLifeStyle: medicalAndLifeStyleReducer,
  stepDetails: SET_STEP_DETAILS,
  common: commonReducer,
  otpVerificationDetails: SET_OTP_VERIFICATION_DETAILS,
  verifyOtpLeadId: SET_VERIFY_OTP_LEAD_ID,
  loanStatus: SET_LOAN_STATUS,
  mefUploadModal: SET_MEF_UPLOAD_MODAL,
  signatureForm: SET_SIGNATURE_MODAL,
  proposalStatus: SET_PROPOSAL_STATUS,
  newLeadDetails: SET_NEW_LEAD_DETAILS,
  assignmentClauseDetails: assignmentClauseDetailsReducer
});
export default appReducer;
